export default __webpack_public_path__ + "static/media/10.20812e58.jpg";